"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageCropperModel = (function () {
    function ImageCropperModel() {
    }
    return ImageCropperModel;
}());
exports.ImageCropperModel = ImageCropperModel;
//# sourceMappingURL=imageCropperModel.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/~/ng2-img-cropper/src/model/imageCropperModel.js
// module id = ../../../../ng2-img-cropper/src/model/imageCropperModel.js
// module chunks = 7